import Swiper from "swiper";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import {countSlides, limitSwiperPagination, resolveSliderLayout} from "../../../../eila-global/js/slider/sliderHelpers.js";

export function initItemboxListPreview() {
    for (const itemboxlistPreview of document.querySelectorAll('.itemboxList.swiper')) {
        const instance = itemboxlistPreview?.swiper;

        if (instance) {
            instance.destroy();
        }

        if (itemboxlistPreview.closest(".contactBanner__box")) {
            try {
                itemboxlistPreview.classList.remove("itemboxList");
                itemboxlistPreview.classList.add("itemboxEilaList");
                for(let blank of itemboxlistPreview.querySelectorAll(".swiper-slide-blank")) {
                    blank.remove();
                }
                let breakpoints = {
                    0: {slidesPerView: 1},
                    768: {slidesPerView: 1.5}
                };

                if(countSlides(itemboxlistPreview) === 1){
                    itemboxlistPreview.classList.add("is-single");
                    breakpoints = {
                        0: {slidesPerView: 1}
                    };
                }

                Swiper.use([Autoplay, Pagination]);
                const swiper = new Swiper(itemboxlistPreview, resolveSliderLayout(itemboxlistPreview, {
                    loop: false,
                    centeredSlides: true,
                    spaceBetween: 0,
                    speed: 400,
                    initialSlide: 0,
                    autoplay: {
                        delay: 5000,
                        pauseOnMouseEnter: true
                    },
                    pagination: {
                        el: itemboxlistPreview.querySelector('.swiper-pagination'),
                        clickable: true
                    },
                    breakpoints: breakpoints,
                }));

                limitSwiperPagination(swiper);
            } catch (error) {
                console.error('Error initializing Swiper:', error);
            }
        }

        if (itemboxlistPreview.closest(".projectItempreview")) {
            try {
                Swiper.use([Autoplay, Navigation]);

                const swiper = new Swiper(itemboxlistPreview, resolveSliderLayout(itemboxlistPreview, {
                    grabCursor: true,
                    spaceBetween: 0,
                    speed: 400,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        pauseOnMouseEnter: true
                    },
                    navigation: {
                        nextEl: itemboxlistPreview.querySelector('.swiper-button-next'),
                        prevEl: itemboxlistPreview.querySelector('.swiper-button-prev'),
                        addIcons: false
                    },
                    breakpoints: {
                        0: {slidesPerView: 1},
                        768: {slidesPerView: 1},
                        1025: {slidesPerView: 1.5}
                    }
                }));
            } catch (error) {
                console.error('Error initializing Swiper:', error);
            }
        }else if(itemboxlistPreview.closest(".itemcardEilaCrosssellerList")){
            try {
                for(let blank of itemboxlistPreview.querySelectorAll(".swiper-slide-blank")) {
                    blank.remove();
                }
                Swiper.use([Autoplay, Navigation, Pagination]);
                const swiper = new Swiper(itemboxlistPreview, resolveSliderLayout(itemboxlistPreview, {
                    loop: true,
                    spaceBetween: 0,
                    speed: 400,
                    initialSlide: 0,
                    autoplay: {
                        delay: 5000,
                        pauseOnMouseEnter: true
                    },
                    navigation: {
                        nextEl: itemboxlistPreview.querySelector('.swiper-button-next'),
                        prevEl: itemboxlistPreview.querySelector('.swiper-button-prev'),
                        addIcons: false
                    },
                    pagination: {
                        el: itemboxlistPreview.querySelector('.swiper-pagination'),
                        clickable: true
                    },
                    breakpoints: {
                        0: {slidesPerView: 1},
                        768: {slidesPerView: 2},
                        1025: {slidesPerView: 3}
                    }
                }));

                limitSwiperPagination(swiper);
            } catch (error) {
                console.error('Error initializing Swiper:', error);
            }
        }
    }

    for (const itemboxlistPreview of document.querySelectorAll('.itemboxSliderHospitalityList.swiper')) {
        const instance = itemboxlistPreview?.swiper;

        if (instance) {
            instance.destroy();
        }

        try {
            Swiper.use([Autoplay, Navigation, Pagination]);
            const swiper = new Swiper(itemboxlistPreview, resolveSliderLayout(itemboxlistPreview, {
                loop: true,
                centeredSlides: true,
                spaceBetween: 0,
                speed: 400,
                autoplay: {
                    delay: 5000,
                    pauseOnMouseEnter: true,
                },
                navigation: {
                    nextEl: itemboxlistPreview.querySelector('.swiper-button-next'),
                    prevEl: itemboxlistPreview.querySelector('.swiper-button-prev'),
                    addIcons: false
                },
                pagination: {
                    el: itemboxlistPreview.querySelector('.swiper-pagination'),
                    clickable: true
                },
                breakpoints: {
                    0: {slidesPerView: 1},
                    1025: {slidesPerView: 2}
                }
            }));

            limitSwiperPagination(swiper);
        } catch (error) {
            console.error('Error initializing Swiper:', error);
        }
    }
}
